var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "settings_page_wrapper" } }, [
    _c("div", { staticClass: "bb-mobile-header" }, [
      _c(
        "div",
        { staticClass: "bb-mobile-header-left" },
        [
          _c(
            "router-link",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab && !_vm.selectedPlace,
                  expression: "activeTab && !selectedPlace",
                },
              ],
              attrs: { to: { name: "settings" } },
            },
            [
              _c("button", { staticClass: "mobile-sidebar-btn" }, [
                _c(
                  "svg",
                  {
                    staticClass: "feather feather-arrow-left",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "22",
                      height: "22",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "#253342",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("line", {
                      attrs: { x1: "19", y1: "12", x2: "5", y2: "12" },
                    }),
                    _c("polyline", { attrs: { points: "12 19 5 12 12 5" } }),
                  ]
                ),
              ]),
            ]
          ),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab && _vm.selectedPlace,
                  expression: "activeTab && selectedPlace",
                },
              ],
              staticClass: "mobile-sidebar-btn",
              on: {
                click: function ($event) {
                  return _vm.unsetSelectedPlace()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-arrow-left",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "22",
                    height: "22",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "#253342",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("line", {
                    attrs: { x1: "19", y1: "12", x2: "5", y2: "12" },
                  }),
                  _c("polyline", { attrs: { points: "12 19 5 12 12 5" } }),
                ]
              ),
            ]
          ),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.activeTab,
                  expression: "!activeTab",
                },
              ],
              staticClass: "mobile-sidebar-btn",
              on: {
                click: function ($event) {
                  return _vm.openMobileAside()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-menu",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("line", {
                    attrs: { x1: "3", y1: "12", x2: "21", y2: "12" },
                  }),
                  _c("line", {
                    attrs: { x1: "3", y1: "6", x2: "21", y2: "6" },
                  }),
                  _c("line", {
                    attrs: { x1: "3", y1: "18", x2: "21", y2: "18" },
                  }),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c("h1", [_vm._v(_vm._s(_vm.mobileHeaderTitle))]),
      _c("div", { staticClass: "bb-mobile-header-right" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeTab && _vm.selectedPlace,
                expression: "activeTab && selectedPlace",
              },
            ],
            staticClass: "mobile-selected-place-actions-btn",
            on: {
              click: function ($event) {
                return _vm.showSelectedPlaceMobileActions()
              },
            },
          },
          [_c("i", { staticClass: "ki ki-more-ver" })]
        ),
      ]),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.activeTab,
            expression: "!activeTab",
          },
        ],
        staticClass: "mobile-tabs-select",
      },
      [
        _vm.$hasRole(_vm.acl.roles.owner) ||
        _vm.$hasPermission(_vm.acl.permissions.manageAccount)
          ? _c("router-link", { attrs: { to: "/settings/widget-settings" } }, [
              _c("div", { staticClass: "mobile-tab-select-item" }, [
                _c("div", { staticClass: "tab-description" }, [
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("settings.mobileTabsSelect.widget.title")
                        ) +
                        " "
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("settings.mobileTabsSelect.widget.description")
                      )
                    ),
                  ]),
                ]),
                _c("button", [_c("i", { staticClass: "la la-angle-right" })]),
              ]),
            ])
          : _vm._e(),
        _vm.$hasRole(_vm.acl.roles.owner) ||
        _vm.$hasPermission(_vm.acl.permissions.manageAccount)
          ? _c("router-link", { attrs: { to: "/settings/account-settings" } }, [
              _c("div", { staticClass: "mobile-tab-select-item" }, [
                _c("div", { staticClass: "tab-description" }, [
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("settings.mobileTabsSelect.account.title")
                        ) +
                        " "
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("settings.mobileTabsSelect.account.description")
                      )
                    ),
                  ]),
                ]),
                _c("button", [_c("i", { staticClass: "la la-angle-right" })]),
              ]),
            ])
          : _vm._e(),
        _vm.$hasRole(_vm.acl.roles.owner) ||
        _vm.$hasPermission(_vm.acl.permissions.manageAccount) ||
        _vm.$hasPermission(_vm.acl.permissions.managePlace)
          ? _c("router-link", { attrs: { to: "/settings/locations" } }, [
              _c("div", { staticClass: "mobile-tab-select-item" }, [
                _c("div", { staticClass: "tab-description" }, [
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("settings.mobileTabsSelect.locations.title")
                        ) +
                        " "
                    ),
                  ]),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "settings.mobileTabsSelect.locations.description"
                        )
                      )
                    ),
                  ]),
                ]),
                _c("button", [_c("i", { staticClass: "la la-angle-right" })]),
              ]),
            ])
          : _vm._e(),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tabs" },
      [
        _vm.$hasRole(_vm.acl.roles.owner) ||
        _vm.$hasPermission(_vm.acl.permissions.manageAccount)
          ? _c("AccountSettingsTab", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "account-settings",
                  expression: "activeTab === 'account-settings'",
                },
              ],
            })
          : _vm._e(),
        _vm.$hasRole(_vm.acl.roles.owner) ||
        _vm.$hasPermission(_vm.acl.permissions.manageAccount) ||
        _vm.$hasPermission(_vm.acl.permissions.managePlace)
          ? _c("LocationsTab", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "locations",
                  expression: "activeTab === 'locations'",
                },
              ],
              ref: "locationsTab",
              on: {
                placeSelected: function ($event) {
                  return _vm.placeSelected($event)
                },
              },
            })
          : _vm._e(),
        _vm.$hasRole(_vm.acl.roles.owner) ||
        _vm.$hasPermission(_vm.acl.permissions.manageAccount)
          ? _c("WidgetSettingsTab", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeTab === "widget-settings",
                  expression: "activeTab === 'widget-settings'",
                },
              ],
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }